(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodScrollToMe', sodScrollToMe);

    function sodScrollToMe($location) {
        return {
            restrict: 'A',
            scope: { id: '@?', offset: '@?' },
            link: function (scope, elem, attrs) {

                var hash = $location.hash();
                if (hash === scope.id) {
                    scrollToListener();
                }
                function scrollToListener() {
                    $('html, body').animate({
                        scrollTop: ($(elem).offset().top) + (parseInt(scope.offset) || 0)
                    }, 500);
                }
            },
        };
    }
})();